var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.002 10.638",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0c6972",
    d: "M6 10.638a5.233 5.233 0 0 0-1.418-.8A4.469 4.469 0 0 0 3 9.547a4.278 4.278 0 0 0-1.125.15 4.939 4.939 0 0 0-1.057.423.525.525 0 0 1-.552-.014A.527.527 0 0 1 0 9.629V3.055a.586.586 0 0 1 .075-.286.472.472 0 0 1 .225-.2 5.7 5.7 0 0 1 1.309-.491A5.945 5.945 0 0 1 3 1.909a5.911 5.911 0 0 1 1.548.2 5.885 5.885 0 0 1 1.453.614v6.9a5.583 5.583 0 0 1 1.459-.675A5.425 5.425 0 0 1 9 8.729a6.633 6.633 0 0 1 1.071.1 3.362 3.362 0 0 1 1.112.4V2.341l.266.109a2.625 2.625 0 0 1 .252.123.649.649 0 0 1 .218.211.514.514 0 0 1 .082.28v6.574a.527.527 0 0 1-.266.477.525.525 0 0 1-.552.014 4.939 4.939 0 0 0-1.057-.423 4.278 4.278 0 0 0-1.125-.15 4.469 4.469 0 0 0-1.582.286A5.233 5.233 0 0 0 6 10.638Zm.818-2.278V3.545L10.365 0v5.278Z",
    "data-name": "auto_stories_FILL1_wght400_GRAD0_opsz48 (1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookOpen);
export default __webpack_public_path__ + "static/media/book-open.b9ee161707f8278cd832fc1a64f9f986.svg";
export { ForwardRef as ReactComponent };